module.exports = __webpack_public_path__ + "img/appAsset-agents-avatar-11.24af7acc.jpg";